const checkInlineValidation = (value, prevData) => {
  return prevData?.name !== value;
};

export default checkInlineValidation;
